import * as React from "react"

const Section = ({ children, fullWidth }) => {
  return (
    <section className={`relative ${fullWidth ? "bg-white" : "bg-gray-50"}`}>
      <div
        className={`max-w-7xl mx-auto px-6 sm:px-8 md:px-24 ${
          fullWidth ? "" : "bg-white"
        }`}
      >
        <div className={"py-20"}>{children}</div>
      </div>
    </section>
  )
}

export default Section
